import { render } from "./UiModalContainer.vue?vue&type=template&id=57dcb20c"
import script from "./UiModalContainer.vue?vue&type=script&lang=js"
export * from "./UiModalContainer.vue?vue&type=script&lang=js"

import "./UiModalContainer.vue?vue&type=style&index=0&id=57dcb20c&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/prod-fe-app-myqampus/node_modules/vue-cli-plugin-vue-next/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__